import { PaymentType, PaymentSubType } from '../../interfaces';

export const mopIcons = {
  [PaymentType.AKTIA]: 'aktia',
  [PaymentType.ALANDSBANKEN]: 'alandsbanken',
  [PaymentType.ALIPAY]: 'alipay',
  [PaymentType.ALIPAY_WAP]: 'alipay',
  [PaymentSubType.AX]: 'amex',
  [PaymentType.APPLE_PAY]: 'applepay',
  [PaymentSubType.DC]: 'dinersclub',
  [PaymentType.GIROPAY]: 'giropay',
  [PaymentType.HANDELSBANKEN]: 'handelsbanken',
  [PaymentType.IDEAL]: 'ideal',
  [PaymentSubType.JC]: 'jcb',
  [PaymentSubType.CA]: 'mastercard',
  [PaymentType.MOBILE_PAY]: 'mobilepay',
  [PaymentType.NORDEA]: 'nordea',
  [PaymentType.NORDEA_ECREDIT]: 'nordea',
  [PaymentType.NORDEA_EE]: 'nordea',
  [PaymentType.NORDEA_SE]: 'nordea',
  [PaymentType.OKO]: 'op',
  [PaymentType.PAYPAL]: 'paypal',
  [PaymentType.POP]: 'poppankki',
  [PaymentType.SAMPO]: 'danskebank',
  [PaymentType.SOFORT]: 'klarna', // Klarna acquired Sofort so we need to use the Klarna icon instead
  [PaymentType.SP]: 'saastopankki',
  [PaymentType.SPANKKI]: 'spankki',
  [PaymentType.TRUSTLY]: 'trustly',
  [PaymentType.UNIONPAY]: 'unionpay',
  [PaymentType.WECHAT]: 'wechatpay',
  [PaymentType.VIPPS]: 'vipps',
  [PaymentType.SWISH]: 'swish',
  [PaymentSubType.VI]: 'visa',
  [PaymentSubType.TP]: 'uatp',
  [PaymentType.GIFT_CARD]: 'gift-card',
  [PaymentType.ADYEN_PAYMENT_CARD]: 'adyenpaymentcard',
  [PaymentType.INDIA_NETBANKING]: 'indianetbanking',
  [PaymentType.INDIA_UPI]: 'upi',
  [PaymentType.INDIA_WALLET]: 'indiawallet',
  [PaymentType.KLARNA]: 'klarna',
  [PaymentType.KLARNA_ACCOUNT]: 'klarna',
  [PaymentSubType.DS]: 'discover',
};
